export const FORM_TYPE_FORGOT_PASSWORD = "forgot_password";
export const FORM_TYPE_FORGOT_USERNAME = "forgot_username";

export const USER_TYPE_INDIVIDUAL = "consumer";
export const USER_TYPE_CORPORATE = "corporate";
export const USER_TYPE_NON_MOBILY = "non-mobily";

// ACCOUNT TYPE
export const ACCOUNT_TYPE_MOBILE = "mobile";
export const ACCOUNT_TYPE_INTERNET = "internet";

// PRODUCT TYPE
export const PRODUCT_TYPE_GSM = "gsm";
export const PRODUCT_TYPE_CONNECT = "connect";
export const PRODUCT_TYPE_FTTH = "ftth";
